<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    @if (formField.label) {
        <label class="form-element-label"> {{ formField.label }}{{ formField.isRequired ? ' *' : '' }} </label>
    }

    <div class="form-control-container">
        @for (star of formField.options.maxStarCount | numberToArray; track star) {
            <sb-inline-svg
                class="icon star-icon"
                (click)="updateStarCount(star)"
                [url]="
                    star <= formField.value
                        ? './sb-tools/theme/images/Svg icons WEB/Settings icons/Star icon - active.svg'
                        : './sb-tools/theme/images/Svg icons WEB/Settings icons/Star icon - inactive.svg'
                ">
            </sb-inline-svg>
        }
    </div>

    <input
        class="d-none"
        id="form-element-{{ formField.id }}"
        type="number"
        name="formField{{ formField.id }}"
        [(ngModel)]="formField.value"
        [required]="formField.isRequired"
        min="1"
        max="formField.options.maxStarCount"
        step="1" />

    @if (formService.isSubmitted && formField.isRequired && !formField.value) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
